export default __webpack_public_path__ + "static/media/dialogue-africa-nigeria-yoruba-logo.f070cb10.png";